// store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slice/authSlice';
import tenantReducer from '../modules/tenant/tenantSlice'; // Make sure this path is correct

export const store = configureStore({
    reducer: {
        auth: authReducer,
        tenant: tenantReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;